import React from 'react'
import Layout from './Layout'
import { pathNames, routesObj, SourceRoute } from './routers/router'
import { Switch, Route, Redirect } from 'react-router-dom'
import RouteWithOtherProps from './controls/RouteWithOtherProps'

import { observer } from 'mobx-react-lite'

import { removeSessionStorage, keyNameSessionStorage, getAccessToken, getRefreshToken } from './utils/sessionStorage'

import LandingPageAdmin from './pages/LandingPageAdmin'
// import useRouterScrollToTop from './controls/useRouterScrollToTop'
import PagePortal from './components/portal/Portal'
import LandingPageSelf from './pages/LandingPageSelf'
import FullReport from './components/report/FullReport'

type AppViewProps = {}
let AppView: React.FC<AppViewProps> = () => {
    const accessToken = getAccessToken()
    const refreshToken = getRefreshToken()
    // useRouterScrollToTop()

    // const fun = () => {
    //     worker.postMessage({
    //         a: '2',
    //     })
    //     worker.onmessage = ({ data }) => {
    //         console.log(data)
    //     }
    // }

    return (
        <>
            <Switch>
                <Route path={pathNames.selfConnect} component={LandingPageSelf} />

                <Route exact path={pathNames.portal} component={PagePortal} />
                <Route {...routesObj.signIn} />
                <Route {...routesObj.register} />
                <Route {...routesObj.forgotPasswordUser} />
                <Route
                    path={pathNames.previewReport}
                    render={() => (
                        <>
                            <Switch>
                                {routesObj.previewReport!.routes?.map((route) => (
                                    <RouteWithOtherProps key={route.path} {...route} />
                                ))}
                            </Switch>
                        </>
                    )}
                />
                <Route path={pathNames.fullReport} component={FullReport} />

                <Route path={pathNames.admin} component={LandingPageAdmin} />

                <Route
                    path={pathNames.user}
                    render={() => (
                        <>
                            <Route
                                exact
                                path={pathNames.user}
                                render={() => <Redirect to={pathNames.userOverview} />}
                            />
                            <Layout routes={routesObj.user!.routes as SourceRoute[]} />
                        </>
                    )}
                />

                {/* <Route exact path={pathNames.portal} render={() => <Redirect to={pathNames.portal} />} /> */}

                <Route
                    exact
                    path='/'
                    render={() => {
                        removeSessionStorage([
                            keyNameSessionStorage.user,
                            keyNameSessionStorage.accessToken,
                            keyNameSessionStorage.refreshToken,
                        ])
                        return <Redirect to={pathNames.signIn} />
                    }}
                />

                {accessToken === null && refreshToken === null && (
                    <Route render={() => <Redirect to={pathNames.signIn} />} />
                )}

                {/* <Route {...routesObj.portal} /> */}
            </Switch>
        </>
    )
}
AppView = observer(AppView)

let App = () => {
    return <AppView />
}

App = observer(App)

export default App
